<div class="row description thema">
  <div class="col-xs-12">
    <ngx-dynamic-hooks [context]="themaContext" [content]="themaContent"></ngx-dynamic-hooks>
  </div>
</div>
